import axios, { CancelToken } from 'axios';
import { createAxiosConfig } from '../mockHelper';
import { EncryptAnalytics, IEncryptAnalyticsRequest } from '../contracts';
import LogCannon from '@ace-clublabs/log-cannon';

export const EncryptAnalyticsApi =
  (endpoint: string): EncryptAnalytics =>
  async (request: IEncryptAnalyticsRequest, cancelToken?: CancelToken) => {
    try {
      const config = createAxiosConfig(null, endpoint);
      delete config.headers['X-AWS-Region'];
      const response = await axios.post(endpoint, request, config);
      LogCannon.blast('EncryptAnalyticsApi success');
      return Promise.resolve(response?.data);
    } catch (e) {
      LogCannon.blast('EncryptAnalyticsApi failed');
      return Promise.resolve({});
    }
  };
